// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2csxU","header":"ReportDetails_header__22oXP","title":"ReportDetails_title__1KoqG","left":"ReportDetails_left__2ZONn"};